export const classes = {
  wrapper: 'place-between mb-4',
  content: 'place-start gap-2 mr-4',
  title: 'text-[17px] font-bold text-taupe-3 dark:text-mauve-1',
  search: 'mr-2',
  addButton: 'ml-4 px-4 py-2 text-sm',
  buttonText: 'ml-2',
};
